module.exports = __webpack_public_path__ + "img/logo5.f0f1aaea.png";